import { JobDetails } from '@borg/types';

class JobRepository extends Repository<JobDetails> {
  get(id: string) {
    return this._get({ url: `/jobs/${id}`, cache: 'always' });
  }
}

export const jobRepository = new JobRepository();
